export default "__VITE_ASSET__65c41f9e__"